module.exports = __webpack_public_path__ + "public/images/slider/slide-4.839d1f4d48e3a5010ad5352132078f77.jpg";